import LineIcon from '@/components/base/LineIcon';

export default function HeroSection() {
  return (
    <section id="top" className="relative w-full min-h-[600px] md:min-h-[680px] lg:min-h-[720px] flex flex-col">
      {/* Background image */}
      <div className="absolute inset-0 z-0">
        <img
          alt="吉川産業の清潔な回収車両と作業スタッフ"
          className="w-full h-full object-cover object-top"
          src="https://readdy.ai/api/search-image?query=Clean%20white%20commercial%20waste%20collection%20truck%20with%20company%20branding%20parked%20on%20a%20quiet%20Kyoto%20residential%20street%20with%20traditional%20Japanese%20houses%20in%20background%20two%20professional%20male%20workers%20in%20clean%20navy%20blue%20uniforms%20standing%20beside%20the%20truck%20loading%20recyclable%20cardboard%20boxes%20and%20waste%20bags%20warm%20golden%20hour%20sunlight%20calm%20trustworthy%20atmosphere%20documentary%20style%20professional%20photography%20high%20detail%20realistic%20no%20AI%20illustration%20look%20authentic%20Japanese%20service%20company%20work%20scene&width=1600&height=900&seq=yoshikawa-hero-v02&orientation=landscape"
        />
      </div>
      {/* Dark overlay for text readability */}
      <div className="absolute inset-0 z-[1] bg-black/50 md:bg-black/45" />

      {/* Content */}
      <div className="relative z-10 flex flex-col flex-1 pt-20 md:pt-24">
        <div className="flex-1 flex items-center">
          <div className="w-full max-w-6xl mx-auto px-5 sm:px-8 md:px-10 lg:px-12 xl:px-16 py-10 md:py-14">
            <div className="flex flex-col lg:flex-row lg:items-center gap-8 lg:gap-12 xl:gap-16">
              {/* Left: Text content */}
              <div className="flex-1 max-w-xl lg:max-w-lg">
                <p className="font-mincho text-accent-300 text-lg md:text-xl tracking-[0.15em] mb-4 md:mb-5">
                  京都の暮らしを、そっと片づける。
                </p>
                <h1 className="font-heading font-bold text-[22px] sm:text-3xl md:text-[32px] lg:text-[36px] text-background-50 leading-[1.8] tracking-wide">
                  京都の不用品回収・古紙回収・遺品整理なら
                  <span className="text-accent-300">吉川産業</span>
                </h1>
                <p className="mt-4 md:mt-5 text-sm md:text-[15px] text-background-50/90 leading-[1.9]">
                  京都市を中心に京都府全域対応。不用品回収・遺品整理・古紙回収・資源回収・
                  産業廃棄物収集運搬・一般廃棄物回収まで、一件一件丁寧に対応いたします。
                </p>
                <div className="mt-6 md:mt-8 flex flex-col gap-3">
                  <div className="flex flex-col sm:flex-row gap-3">
                    <a
                      href="tel:+81120219620"
                      className="flex-1 inline-flex items-center justify-center gap-2 px-6 py-4 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 font-bold text-sm md:text-base whitespace-nowrap cursor-pointer transition-colors"
                    >
                      <span className="w-5 h-5 flex items-center justify-center text-base">
                        <i className="ri-phone-fill" />
                      </span>
                      電話で今すぐ相談
                    </a>
                    <a
                      href="https://lin.ee/yKaHc4I"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex-1 inline-flex items-center justify-center gap-2.5 px-6 py-4 rounded-md bg-accent-700 hover:bg-accent-800 text-background-50 font-bold text-sm md:text-base whitespace-nowrap cursor-pointer transition-colors"
                    >
                      <LineIcon className="w-5 h-5 shrink-0" />
                      LINEで無料見積り
                    </a>
                  </div>
                  <p className="text-xs text-background-50/70 text-left leading-relaxed">
                    写真を送るだけ！最短5分で概算お見積り。お見積りだけでも大歓迎です。
                  </p>
                </div>
              </div>

              {/* Right: Popular plan card */}
              <div className="lg:w-[400px] xl:w-[440px] shrink-0 w-full flex flex-col gap-5 lg:self-center">
                <div className="bg-white/90 backdrop-blur-sm border border-background-200/50 rounded-2xl p-6 md:p-8 shadow-sm relative overflow-hidden">
                  <div className="absolute top-0 left-0 right-0 h-1.5 bg-accent-500" />
                  <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-accent-500 text-background-50 text-xs md:text-sm font-bold tracking-widest mb-4 whitespace-nowrap">
                    <span className="w-4 h-4 flex items-center justify-center text-sm">
                      <i className="ri-sparkling-2-line" />
                    </span>
                    人気No.1プラン
                  </span>
                  <h3 className="font-heading font-bold text-xl md:text-2xl text-foreground-900 mb-3">
                    かご台車1台
                  </h3>
                  <div className="flex items-baseline gap-x-2 gap-y-1 mb-4">
                    <span className="font-heading font-bold text-5xl md:text-6xl text-primary-600 leading-none tracking-tight">
                      9,000
                    </span>
                    <span className="font-heading font-bold text-2xl md:text-3xl text-primary-600 leading-none">
                      円〜
                    </span>
                    <span className="text-xs text-foreground-500 ml-1">(税込)</span>
                  </div>
                  <p className="text-sm md:text-[15px] text-foreground-600 leading-relaxed mb-5">
                    少量の不用品回収におすすめのプランです。家庭から出る不用品・ゴミを、かご台車1台分を目安に回収いたします。
                  </p>
                  <ul className="space-y-2.5 mb-4">
                    <li className="flex items-start gap-2 text-sm md:text-[15px] text-foreground-700">
                      <span className="w-5 h-5 mt-0.5 flex items-center justify-center text-primary-600 shrink-0">
                        <i className="ri-check-line" />
                      </span>
                      <span>45Lゴミ袋 約25〜30袋</span>
                    </li>
                    <li className="flex items-start gap-2 text-sm md:text-[15px] text-foreground-700">
                      <span className="w-5 h-5 mt-0.5 flex items-center justify-center text-primary-600 shrink-0">
                        <i className="ri-check-line" />
                      </span>
                      <span>ダンボール 約15箱程度</span>
                    </li>
                    <li className="flex items-start gap-2 text-sm md:text-[15px] text-foreground-700">
                      <span className="w-5 h-5 mt-0.5 flex items-center justify-center text-primary-600 shrink-0">
                        <i className="ri-check-line" />
                      </span>
                      <span>小型家具・衣類・生活用品も回収可能</span>
                    </li>
                  </ul>
                  <p className="text-xs text-foreground-500 leading-relaxed mb-5">
                    ※回収品目・重量・搬出状況・作業内容により料金が変動する場合があります。
                  </p>
                  <div className="rounded-xl overflow-hidden bg-white border border-background-200">
                    <img
                      alt="かご台車1台 9,000円〜の料金案内インフォグラフィック。ゴミの量でわかりやすい安心料金。かご台車1台(幅約110cm×奥行約80cm×高さ約170cm、積載量約1.2㎡・400kgまで)で9,000円〜(税込)。可燃ゴミ袋約30〜40袋、段ボール約10〜20枚、木くず・小型家具、ペットボトル・缶多数、その他不用品いろいろが積み込めます。"
                      className="w-full h-auto object-contain"
                      src="https://static.readdy.ai/image/9751c2861f77ccab088a483472b903b8/6d7a5137bf1e5be6f4f244a6622b3b20.png"
                    />
                  </div>
                </div>

                {/* Mini badges */}
                <div className="grid grid-cols-2 gap-3">
                  <div className="flex items-center gap-2">
                    <div className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-50 shrink-0">
                      <span className="w-4 h-4 flex items-center justify-center text-primary-600 text-sm">
                        <i className="ri-timer-flash-line" />
                      </span>
                    </div>
                    <span className="text-xs font-bold text-foreground-800 whitespace-nowrap">最短即日対応</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <div className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-50 shrink-0">
                      <span className="w-4 h-4 flex items-center justify-center text-primary-600 text-sm">
                        <i className="ri-money-cny-circle-line" />
                      </span>
                    </div>
                    <span className="text-xs font-bold text-foreground-800 whitespace-nowrap">見積無料</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <div className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-50 shrink-0">
                      <span className="w-4 h-4 flex items-center justify-center text-primary-600 text-sm">
                        <i className="ri-check-double-line" />
                      </span>
                    </div>
                    <span className="text-xs font-bold text-foreground-800 whitespace-nowrap">追加料金なし</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <div className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-50 shrink-0">
                      <span className="w-4 h-4 flex items-center justify-center text-primary-600 text-sm">
                        <i className="ri-map-pin-line" />
                      </span>
                    </div>
                    <span className="text-xs font-bold text-foreground-800 whitespace-nowrap">京都府全域対応</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom info bar */}
        <div className="w-full max-w-6xl mx-auto px-5 sm:px-8 md:px-10 lg:px-12 xl:px-16 pb-6 md:pb-8">
          <div className="bg-background-50/95 backdrop-blur-sm border border-background-200 rounded-lg p-5 md:p-6">
            <div className="flex flex-col lg:flex-row lg:items-center gap-5 md:gap-6">
              <a
                href="tel:+81120219620"
                className="flex items-center gap-3 text-primary-800 hover:text-primary-700 transition-colors cursor-pointer shrink-0"
              >
                <div className="w-11 h-11 flex items-center justify-center rounded-full bg-primary-100 shrink-0">
                  <span className="w-5 h-5 flex items-center justify-center text-primary-600 text-xl">
                    <i className="ri-phone-fill" />
                  </span>
                </div>
                <div>
                  <p className="text-xs text-primary-700 font-medium tracking-wide">
                    お電話でのお問い合わせ
                  </p>
                  <p className="font-heading font-bold text-2xl md:text-[28px] text-primary-800 tracking-wide">
                    0120-219-620
                  </p>
                </div>
              </a>
              <div className="hidden lg:block w-px h-12 bg-primary-200 shrink-0" />
              <div className="flex-1 grid grid-cols-2 md:grid-cols-4 gap-x-4 gap-y-3">
                <div className="flex items-start gap-2">
                  <div className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-100 shrink-0 mt-0.5">
                    <span className="w-4 h-4 flex items-center justify-center text-primary-600 text-sm">
                      <i className="ri-map-pin-line" />
                    </span>
                  </div>
                  <div>
                    <p className="text-[11px] text-primary-700 font-medium leading-none mb-0.5">
                      所在地
                    </p>
                    <p className="text-xs text-foreground-700 leading-snug">
                      〒606-8222
                    </p>
                    <p className="text-xs text-foreground-700 leading-snug">
                      京都府京都市左京区田中上玄京町53-1
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-2">
                  <div className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-100 shrink-0 mt-0.5">
                    <span className="w-4 h-4 flex items-center justify-center text-primary-600 text-sm">
                      <i className="ri-time-line" />
                    </span>
                  </div>
                  <div>
                    <p className="text-[11px] text-primary-700 font-medium leading-none mb-0.5">
                      営業時間
                    </p>
                    <p className="text-xs text-foreground-700 leading-snug">
                      9:00〜17:00
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-2">
                  <div className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-100 shrink-0 mt-0.5">
                    <span className="w-4 h-4 flex items-center justify-center text-primary-600 text-sm">
                      <i className="ri-calendar-check-line" />
                    </span>
                  </div>
                  <div>
                    <p className="text-[11px] text-primary-700 font-medium leading-none mb-0.5">
                      定休日
                    </p>
                    <p className="text-xs text-foreground-700 leading-snug">
                      年中無休
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-2">
                  <div className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-100 shrink-0 mt-0.5">
                    <span className="w-4 h-4 flex items-center justify-center text-primary-600 text-sm">
                      <i className="ri-focus-3-line" />
                    </span>
                  </div>
                  <div>
                    <p className="text-[11px] text-primary-700 font-medium leading-none mb-0.5">
                      対応エリア
                    </p>
                    <p className="text-xs text-foreground-700 leading-snug">
                      京都市
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}